var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseSmall = function SvgCloseSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.171 5.997a.584.584 0 0 1 .826-.826L12 11.175l6.003-6.004a.584.584 0 0 1 .826.826L12.825 12l6.004 6.003a.583.583 0 0 1-.413.997.583.583 0 0 1-.413-.171L12 12.825l-6.003 6.004a.582.582 0 0 1-.953-.19.584.584 0 0 1 .127-.636L11.175 12 5.171 5.997Z"
  })));
};
export default SvgCloseSmall;